import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Schibsted_Grotesk\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-display\",\"weight\":[\"500\",\"600\",\"700\",\"800\"]}],\"variableName\":\"displayFont\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Public_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-body\",\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"bodyFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/persistantProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ChatBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MetaPixel.tsx");
